import recoveredEntries from './recoveredSalesProofs.json';
import additionalEntries from './additionalSalesProofs.json';
import visibility from './salesProofVisibility.json';

// Original records stay intact; hide inaccessible images with the owner's approval.
const excludedIds = new Set([...visibility.illustrativeIds, ...visibility.hiddenIds]);

export const salesProofs = [...additionalEntries, ...recoveredEntries].filter((proof) => !excludedIds.has(proof.id));

export const proofCategories = [
  { id: 'all', label: 'All Proof' },
  { id: 'shopify-store', label: 'Shopify Store' },
  { id: 'amazon-book', label: 'Amazon Book' }
];

export const proofCategoryLabel = (category) =>
  proofCategories.find((item) => item.id === category)?.label || category;

export const proofDate = (date) => new Date(date).toLocaleDateString('en-US', {
  month: 'long', year: 'numeric', timeZone: 'UTC'
});